import { ICellRendererParams } from 'ag-grid-community'
import { ProjectPlanCumulation } from '../../../../../lib/functions/projectPlan'
import { RootDiv } from '../../../commons/AgGrid/components/cell/CellRendererRoot'
import { NewWbsItemRow } from '../../../../pages/ProjectPlanNew/projectPlanNew'
import { colorPalette } from '../../../../style/colorPalette'
import { useMemo } from 'react'
import { FontSize, FontWeight } from '../../../../../styles/commonStyles'
import { TicketCumulation } from '../../../../../lib/functions/ticketList'

const Fraction = ({ total, done }: { total: number; done: number }) => {
  const displayVal = useMemo(() => {
    return `(${done} / ${total})`
  }, [total, done])
  return (
    <div
      style={{
        fontSize: FontSize.SMALL,
        color: colorPalette.monotone[4],
        fontWeight: FontWeight.NORMAL,
        textAlign: 'left',
      }}
    >
      {displayVal}
    </div>
  )
}
const PercentageLabel = ({
  children,
  total,
}: {
  children: string
  total: number
}) => {
  return <p style={{ margin: '0 1px' }}>{children}</p>
}

export interface Params extends ICellRendererParams {
  hideChildrenCount?: boolean
}
export const ProjectPlanProgressRateCellRenderer = (params: Params) => {
  const wbsItem: NewWbsItemRow =
    params.data?.body?.wbsItem ?? params.data?.wbsItem
  const cumulation: ProjectPlanCumulation =
    params.data?.body?.cumulation ?? params.data?.cumulation
  if (!wbsItem || !params.colDef || !cumulation) {
    return <></>
  }
  if (wbsItem.wbsItemType.isTask()) {
    const total = cumulation.countTask - cumulation.countStatusTaskDiscard
    const done = cumulation.countStatusTaskDone
    if (total > 0 && !params.hideChildrenCount) {
      return (
        <RootDiv
          style={{ paddingLeft: '0px', marginLeft: '12px', textAlign: 'left' }}
        >
          <Fraction total={total} done={done} />
        </RootDiv>
      )
    }
    return <RootDiv style={{ marginLeft: '12px', textAlign: 'left' }} />
  }

  const total = wbsItem.wbsItemType.isDeliverable()
    ? cumulation.countTask - cumulation.countStatusTaskDiscard
    : cumulation.countDeliverable - cumulation.countStatusDeliverableDiscard
  const done = wbsItem.wbsItemType.isDeliverable()
    ? cumulation.countStatusTaskDone
    : cumulation.countStatusDeliverableDone
  return <ProgressRate total={total} done={done} />
}

export const TicketProgressRateCellRenderer = (params: Params) => {
  const cumulation: TicketCumulation = params.data?.ticketCumulation
  if (!params.colDef || !cumulation) {
    return <></>
  }

  const total = cumulation.countTicket
  const done = cumulation.countTicketDone
  return <ProgressRate total={total} done={done} />
}

const ProgressRate = ({ total, done }: { total: number; done: number }) => {
  return (
    <RootDiv
      style={{ paddingLeft: '0px', marginLeft: '12px', textAlign: 'left' }}
    >
      <PercentageLabel total={total}>
        {!total ? '0.0%' : `${((done / total) * 100).toFixed(1)}%`}
      </PercentageLabel>
      <div style={{ marginLeft: '6px' }}>
        <Fraction total={total} done={done} />
      </div>
    </RootDiv>
  )
}
